import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import html2pdf from 'html2pdf.js';
import ReactDOM from 'react-dom';
import InvoicesViews from "./InvoicesView";
import UpdateInvoice from "./InvoiceUpdate";
import CustomDateRangePicker from "../CustomDateRangePicker";
import vAdminformat from "../../adminFormat";


const server_backend = config.API_URL;

const Invoices = ({ email }) => {
    const [InvoicesList, setInvoicesList] = useState([]);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBInvoices, setViewBInvoices] = useState(false);
    const [updateBInvoices, setUpdateBInvoices] = useState(false);
    const [currentInvoices, setCurrentInvoices] = useState(0);
    const [statusInvoice, setStatusInvoice] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });


    const itemsPerPage = 10;

    useEffect(() => {
        const getInvoices = async () => {
            try {
                const response = await axios.get(`${server_backend}/invoices/list`, headers);
                //console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setInvoicesList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getInvoices();
    }, []);

    useEffect(() => {
        const getInvoices = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/invoice`, headers);
                //console.log({ HEAD: response.data });
                if (response.data.RES_CODE === "00") {
                    setStatusInvoice(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getInvoices();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Invoices/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setInvoicesList(response.data.RES_RESULT);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewInvoices = () => {
        setViewBInvoices(true);
    }

    const CloseViewInvoices = () => {
        setViewBInvoices(false);
    }

    const downloadInvoice = (Invoices) => {
        return new Promise((resolve, reject) => {
            const tempDiv = document.createElement('div');
            document.body.appendChild(tempDiv);

            ReactDOM.render(
                <InvoicesViews
                    InvoicesID={Invoices.inv_ID}
                    onRenderComplete={() => {
                        // HTML2PDF configuration

                        const options = {
                            margin: 0,
                            filename: `invoice_${Invoices.name}.pdf`,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: { scale: 2 },
                            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                        };

                   
                        const element = document.getElementById('invoice-container');
                        html2pdf().set(options).from(element).save().then(() => {
                          
                            ReactDOM.unmountComponentAtNode(tempDiv);
                            document.body.removeChild(tempDiv);
                            resolve();
                        }).catch(error => {
                            reject(error);
                            console.error('Error generating PDF:', error);
                            ReactDOM.unmountComponentAtNode(tempDiv);
                            document.body.removeChild(tempDiv);
                        });
                    }}
                />,
                tempDiv
            );
        });
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = InvoicesList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(InvoicesList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const showUpdateInvoices = () => {
        setUpdateBInvoices(true);
    }

    const CloseUpdateInvoices = () => {
        setUpdateBInvoices(false);
    }


 const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBInvoices ? (
                <InvoicesViews InvoiceID={currentInvoices} CloseViewInvoices={CloseViewInvoices} />
            ) : (

                <div>

                    {updateBInvoices ? (
                        <UpdateInvoice InvoiceID={currentInvoices} CloseUpdateInvoices={CloseUpdateInvoices} />

                    ) : (

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Invoices List</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Invoices</a></li>
                                                <li className="breadcrumb-item active">Invoices List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header bInvoices-0">
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">All Invoices</h5>
                                                <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                        <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                    </button>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    {/*    <Link className="btn btn-success add-btn" to="/create-invoice">
                                                    <i className="ri-add-line align-bottom me-1"></i> Generate Invoice
                                                </Link>
     */}
                                                    <div className="btn-group">
                                                        <button type="button" className="btn btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                            Generate Invoice
                                                        </button>
                                                        <div className="dropdown-menu dropdownmenu-success">
                                                            <Link className="dropdown-item" to="/create-invoice-from-order">From Order</Link>
                                                            <Link className="dropdown-item" to="/create-invoice-from-customer">From Customer</Link>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body bInvoices bInvoices-dashed bInvoices-end-0 bInvoices-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabled}
                                                                value={filterBy}
                                                                onChange={handleFilterByChange}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="inv_ID">ID</option>
                                                                <option value="fullname">Customer name</option>
                                                                <option value="email">Email</option>
                                                                <option value="phone">Phone</option>
                                                                <option value="subtotal">Subtotal</option>
                                                                <option value="tax">Tax</option>
                                                                <option value="total">Total</option>
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                data-choices
                                                                data-choices-search-false
                                                                name="choices-single-default"
                                                                id="idFilterStatus"
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterStatusChange}
                                                            >
                                                                <option value={0}>Filter status</option>
                                                                {statusInvoice.map((status) => (
                                                                    <option value={status.est_ID}>{status.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                    <CustomDateRangePicker onDateChange={handleDateChange} />
                                                </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterValueChange}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                        <div className="card-body">
                                        <div
  className="table-responsive table-card mb-4"
  style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
>
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light text-muted">
                                                        <tr>
                                                            <th className="th-hover" onClick={() => handleColumnClick("inv_ID")}>ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Full name</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("date_created")}>Dated Created</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("subtotal")}>Subtotal</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("tax")}>Tax</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("total")}>Total</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="list form-check-all">
                                                        {currentItems.map((Invoices_L) => (
                                                            <tr key={Invoices_L.inv_ID}>
                                                                <th scope="row">
                                                                    <div className="form-check">
                                                                        {Invoices_L.inv_ID}
                                                                    </div>
                                                                </th>
                                                                <td className="client_name">{Invoices_L.fullname}</td>

                                                                <td className="assignedto">
                                                                    {Invoices_L.phone}
                                                                </td>
                                                                <td className="date">{vAdminformat.FormatDate(Invoices_L.date_created)}</td>
                                                                
                                                                <td className="assignedto">
                                                                    {Invoices_L.subtotal}
                                                                </td>
                                                                <td className="assignedto">
                                                                    {Invoices_L.tax}
                                                                </td>
                                                                <td className="assignedto">
                                                                    {Invoices_L.total}
                                                                </td>

                                                                <td className="status">
                                                                    <span className={`${Invoices_L.est_ID === 15 ? "badge badge-soft-success text-uppercase"
                                                                        : (
                                                                            Invoices_L.est_ID === 14 ? "badge badge-soft-warning text-uppercase"
                                                                                : (
                                                                                    Invoices_L.est_ID === 16 ? "badge badge-soft-danger text-uppercase" : null
                                                                                )
                                                                        )} text-uppercase`}>
                                                                        {Invoices_L.status_name}
                                                                    </span>
                                                                </td>
                                                                <td className="due_date">
                                                                    <ul className="list-inline hstack gap-2 mb-0 fs-5">

                                                                        <li className="list-inline-item" >
                                                                            <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                                setCurrentInvoices(Invoices_L.inv_ID);
                                                                                showViewInvoices()
                                                                            }}>
                                                                                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                            </Link>
                                                                        </li>

                                                                        <li className="list-inline-item edit">
                                                                            <Link type="button"
                                                                                className="text-primary d-inline-block edit-item-btn"
                                                                                data-toggle="tooltip"
                                                                                data-placement="top" title="Update " onClick={() => {
                                                                                    setCurrentInvoices(Invoices_L.inv_ID);
                                                                                    showUpdateInvoices()
                                                                                }}>
                                                                                <i className="ri-pencil-fill fs-16"></i>
                                                                            </Link></li>

                                                                        <li className="list-inline-item edit">
                                                                            <Link
                                                                                type="button"
                                                                                onClick={() => downloadInvoice(Invoices_L)}
                                                                                className="text-primary d-inline-block edit-item-btn"
                                                                            >
                                                                                <i className="ri-download-2-line"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-auto me-3">
                                                    <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, InvoicesList.length)} of {InvoicesList.length} entries</p>
                                                </div>
                                                <div className="col-auto">
                                                    <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                        </li>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="row g-0 text-center text-sm-start">
                                                <div className="col-sm-6">
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}




                </div>
            )}
        </div>
    );
};

export default Invoices;
